import ErrorOverlay, { AJAX_ERROR_STREAM_SUBTITLE, NO_CONTENT_MESSAGE, NO_CONTENT_MESSAGE_FAVORITES } from 'components/ErrorOverlay'
import EmptyFetchError, { FetchError } from 'components/Fetch/FetchError'
import { FilterType } from 'interfaces'
import * as React from 'react'
import { useIntl } from 'react-intl'

interface ContentGridViewErrorProps {
  filter: FilterType
  hasItems: boolean
  error: any
  offset: number
  isStream?: boolean
  errorElement?: React.ReactNode
  isFavoritesView?: boolean
}

export const ContentGridViewError = (props: ContentGridViewErrorProps) => {
  const intl = useIntl()
  const { filter, hasItems, error, offset, isStream, errorElement, isFavoritesView } = props

  if (typeof error?.response?.message === 'string') {
    return (
      <ErrorOverlay
        originalError={error}
        error={error.response.message}
        subtitle=""
        offset={0}
        contentType={filter}
      />
    )
  }

  if (errorElement && !hasItems) {
    return errorElement as any
  }

  if (error instanceof EmptyFetchError) {
    const errorMessage = hasItems
      ? intl.formatMessage({ id: 'content.msg-no-content-for-range' })
      : isFavoritesView
        ? NO_CONTENT_MESSAGE_FAVORITES(filter, intl.formatMessage)
        : NO_CONTENT_MESSAGE(filter, isStream, intl.formatMessage)

    const subtitle = hasItems ? '' : intl.formatMessage({ id: `content.msg-no-content-subtitle${isStream ? '-stream' : ''}` })

    return (
      <ErrorOverlay
        originalError={error}
        error={errorMessage}
        subtitle={subtitle}
        offset={offset}
        contentType={filter}
        small={hasItems}
      />
    )
  }

  const errorMessage = intl.formatMessage({ id: isStream ? 'content.msg-server-error-stream' : 'content.msg-server-error-feed' })
  const subtitle = AJAX_ERROR_STREAM_SUBTITLE(intl.formatMessage)

  if (error instanceof FetchError) {
    return (
      <ErrorOverlay
        originalError={error}
        error={errorMessage}
        subtitle={subtitle}
        offset={offset}
        contentType={filter}
      />
    )
  }

  if (hasItems) {
    return null
  }

  return (
    <ErrorOverlay
      originalError={error || '<no error>'}
      error={errorMessage}
      subtitle={subtitle}
      offset={offset}
    />
  )
}

export default ContentGridViewError
